export enum OnBoardingStatus {
  None = 0,
  New = 1,
  Sent = 2,
  Completed = 3,
  Converted = 4
}
